<template>
  <div style="height: 100%">
    <div v-if="isBiancaOrRossa">
      <b-alert v-if="tipologia == 'ROSSA' && !validationNre" show variant="warning">NRE obbligatorio</b-alert>
    </div>
    <accettazione-ssn-struttura-presidio-component :jsonData="jsonData.accettazione" :isEdit="isEdit" @changeJsonValues="onChangeAccettazioneJSON" />
    <accettazione-ssn-anagrafica-component :jsonData="jsonData.accettazione.accettazioneAnagrafica" :isEdit="isEdit" @changeJsonValues="onChangeAccettazioneAnagraficaJSON" />
    <b-card class="sa-card sa-card-border" :header="`Impegnativa`" header-tag="header" footer-tag="footer" title="">
      <b-row class="sa-padding-left text-left" style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 2rem">
        <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
          <label class="sa-label-data">Note Caratteristiche Paziente</label>
          <b-form-input :disabled="!isEdit" v-model="jsonData.noteCaratteristichePaziente"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Stato Civile</label>
          <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.statoCivile" class="mb-2 mr-sm-2 mb-sm-0" :options="statoCivileOptions" :value="null">
            <template #first>
              <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="5" xl="5">
          <label class="sa-label-data">Partita Iva</label>
          <b-form-input :disabled="!isEdit" v-model="jsonData.partitaIva"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="5" xl="5">
          <label class="sa-label-data">Identificazione Istituzione</label>
          <b-form-input :disabled="!isEdit" v-model="jsonData.identificazioneIstituzione"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Tipologia Documento</label>
          <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.tipologiaDocumento" class="mb-2 mr-sm-2 mb-sm-0" :options="tipologiaDocumentoOptions" :value="null">
            <template #first>
              <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Documento</label>
          <b-input-group class="mt-3">
            <b-form-input v-model="jsonData.documento" :disabled="!isEdit"></b-form-input>
            <b-input-group-append>
              <b-button variant="outline-info" @click="isSprovistoDocumento = !isSprovistoDocumento">Sprovisto</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Identificazione Tessera</label>
          <b-form-input :disabled="!isEdit" v-model="jsonData.identificazioneTessera"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">{{ selectedCheckBoxs.includes("stp") || selectedCheckBoxs.includes("eni") ? "Scadenza STP/ENI" : "Scadenza Tessera" }}</label>
          <date-picker v-if="selectedCheckBoxs.includes('stp') || selectedCheckBoxs.includes('eni')" format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.scadenzaStpEni" type="date"></date-picker>
          <date-picker v-else format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.scadenzaStpEni" type="date"></date-picker>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Rilasciato da</label>
          <b-form-input :disabled="!isEdit" v-model="jsonData.rilasciatoDa"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2"> </b-col>
      </b-row>
    </b-card>
    <b-card class="sa-card sa-card-border" :header="`Impegnativa`" header-tag="header" footer-tag="footer" title="">
      <b-row class="sa-padding-left text-left" style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 2rem">
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <label class="sa-label-data">
            <b-form-group label="Accettazione" v-slot="{ ariaDescribedby }">
              <b-form-checkbox-group v-model="selectedCheckBoxs" :options="optionsCheckBoxGroup" :aria-describedby="ariaDescribedby" switches></b-form-checkbox-group>
            </b-form-group>
          </label>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="5" xl="5">
          <label class="sa-label-data">Numero Impegnativa (NRE)</label>
          <b-row>
            <b-col cols="4" xs="12" sm="12" md="4" lg="4" xl="4"> <b-form-input :disabled="!isEdit" v-model="jsonData.codiceBar1"></b-form-input></b-col>
            <b-col cols="8" xs="12" sm="12" md="8" lg="8" xl="8"> <b-form-input :disabled="!isEdit" v-model="jsonData.codiceBar2"></b-form-input></b-col>
          </b-row>
        </b-col>

        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Data Prescrizione</label>
          <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataPrescrizione" type="date"></date-picker>
        </b-col>

        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Data inizio erogazione</label>
          <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataInizioErogazione" type="date"></date-picker>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Data fine erogazione</label>
          <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataFineErogazione" type="date"></date-picker>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="1" xl="1">
          <label class="sa-label-data">Regione</label>
          <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.presRegione" class="mb-2 mr-sm-2 mb-sm-0" :options="presRegioniOptions" :value="null">
            <template #first>
              <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Matricola</label>
          <b-input-group class="mt-3">
            <b-form-input v-model="jsonData.matricola" :disabled="!isEdit"></b-form-input>
            <b-input-group-append>
              <b-button variant="outline-info"><font-awesome-icon icon="search" /></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Pres. Cognome</label>
          <b-form-input :disabled="!isEdit" v-model="jsonData.presCognome"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Pres. Nome</label>
          <b-form-input :disabled="!isEdit" v-model="jsonData.presNome"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Pres. Codice Fiscale</label>
          <b-form-input :disabled="!isEdit" v-model="jsonData.presCodiceFiscale"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="1" xl="1">
          <label class="sa-label-data">Tipologia</label>
          <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.presTipologia" class="mb-2 mr-sm-2 mb-sm-0" :options="presTipologiaOptions" :value="null">
            <template #first>
              <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="5" xl="5">
          <label class="sa-label-data">Diagnosi codificata</label>
          <b-input-group class="mt-3">
            <b-form-input v-model="jsonData.diagnosi" :disabled="!isEdit"></b-form-input>
            <b-input-group-append>
              <b-button variant="outline-info"><font-awesome-icon icon="search" /></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="1" xl="1">
          <label class="sa-label-data">Non Esente</label>
          <b-form-checkbox switch v-model="jsonData.nonEsente"></b-form-checkbox>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="1" xl="1">
          <label class="sa-label-data">Reddito</label>
          <b-form-checkbox switch v-model="jsonData.esenteReddito"></b-form-checkbox>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Codice Esenzione</label>
          <b-input-group class="mt-3">
            <b-form-input v-model="jsonData.codiceEsenzione" :disabled="!isEdit"></b-form-input>
            <b-input-group-append>
              <b-button variant="outline-info"><font-awesome-icon icon="search" /></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Priorità</label>
          <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.priorita" class="mb-2 mr-sm-2 mb-sm-0" :options="presTipologiaOptions" :value="null">
            <template #first>
              <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
      </b-row>
      <template #footer>
        <em>
          <b-row>
            <b-col cols="12" class="text-right">
              <b-button @click="onAggiungiImpegnativa" variant="outline-info"><font-awesome-icon icon="save" /> <span>Aggiungi Impegnativa</span></b-button>
            </b-col>
          </b-row>
        </em>
      </template>
    </b-card>
    <hr />
    <b-card class="sa-card sa-card-border" header="Impegnativa dettaglio prestazioni" header-tag="header" footer-tag="footer" title="">
      <b-row class="sa-padding-left text-left" style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 2rem">
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <accettazione-ssn-ricetta-prestazioni-component @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" :tipologia="tipologia" :impegnative="impegnative" />
        </b-col>
      </b-row>
    </b-card>
    <b-card class="sa-card sa-card-border" header="Riepilogo" header-tag="header" footer-tag="footer" title="">
      <b-row class="sa-padding-left text-left" style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 2rem">
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Tipo Acc</label>
          <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.tipoAccesso" class="mb-2 mr-sm-2 mb-sm-0" :options="tipologiaAccessoOptions" :value="null">
            <template #first>
              <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
          <label class="sa-label-data">Data ora Accettazione</label>
          <date-picker format="DD/MM/YYYY hh:mm" value-type="timestamp" v-model="jsonData.dataNascita" type="datetime"></date-picker>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
          <label class="sa-label-data">Importo</label>
          <b-form-input :disabled="true" v-model="jsonData.importoTotale"></b-form-input>
        </b-col>

        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12"> RIEPILOGO TODO TABLE COMPONENT </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
import AccettazioneSsnRicettaPrestazioniComponent from "./AccettazioneSsnRicettaPrestazioniComponent.vue";
import AccettazioneSsnStrutturaPresidioComponent from "./AccettazioneSsnStrutturaPresidioComponent.vue";
import AccettazioneSsnAnagraficaComponent from "./AccettazioneSsnAnagraficaComponent.vue";
import axios from "axios";
export default {
  props: {
    isEdit: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    jsonData: {
      type: Object,
      default: () => {
        return {
          accettazione: {
            accettazioneAnagrafica: {},
            accettazioneAsl: {},
          },
        };
      },
    },
    tipologia: {
      type: String,
      default: () => {
        return null;
      },
    },
  },
  components: {
    AccettazioneSsnRicettaPrestazioniComponent,
    AccettazioneSsnStrutturaPresidioComponent,
    AccettazioneSsnAnagraficaComponent,
    DatePicker,
  },
  data() {
    return {
      linkStrutture: "/strutture",
      strutturaOptions: [],

      linkProvince: "/province",
      provinciaNascitaOptions: [],

      linkComune: "/comuni/provincia",
      comuniNascitaOptions: [],

      provinciaOptions: [],
      distrettiOptions: [],
      presTipologiaOptions: [],
      presRegioniOptions: [],
      impegnative: [],

      tipologiaAccessoOptions: [],
      optionsCheckBoxGroup: [
        { text: "Anonimato", value: "anonimato" },
        { text: "STP", value: "stp" },
        { text: "ENI", value: "eni" },
        { text: "Conv", value: "conv" },
        { text: "TEAM", value: "team" },
        { text: "Cons", value: "cons" },
        { text: "Email", value: "emailBox" },
        { text: "Sconosciuto", value: "sconosciuto" },
      ],
      statoCivileOptions: [
        { text: "Celibe/Nubile", value: "celibenubile" },
        { text: "Coniugato/a", value: "coniugato" },
        { text: "Separato/a", value: "separato" },
        { text: "Vedovo/a", value: "vedovo" },
        { text: "Non Dichiarato", value: "nondichiarato" },
      ],
      tipologiaDocumentoOptions: [],
      selectedCheckBoxs: [],
      isResidenzaUgualeDomicilio: false,
      showModalLoading: false,
      isSprovistoDocumento: false,
      listKey: 0,
      filtro: {},
      impegnativa: {},
      prestazione: {},
    };
  },
  mixins: { UtilityMixin },
  mounted() {
    //let me = this;
  },
  computed: {
    isBiancaOrRossa() {
      let me = this;
      if (me.tipologia == "ROSSA") {
        return true;
      } else if (me.tipologia == "BIANCA") {
        return true;
      } else {
        return false;
      }
    },
    validationNre() {
      let me = this;
      if (me.tipologia === "ROSSA") {
        return me.jsonData.nre.length >= 15;
      } else if (me.tipologia == "BIANCA") {
        return true;
      } else {
        return true;
      }
    },
  },

  methods: {
    init(jsonData) {
      let me = this;
      me.jsonData = jsonData;
      me.$emit("sendErrorsAlert", jsonData.listaErrori);
      me.$emit("beforeLoadData");
    },
    loadStrutture() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.pathResourceStrutture;
      axios
        .get(link)
        .then((response) => {
          me.strutturaOptions = [];
          me.rows = response.data.data.recordsNumber;
          me.strutturaOptions = response.data.data;

          if (me.strutturaOptions.length === 1) {
            me.jsonData.codiceStruttura = me.strutturaOptions[0].codiceStruttura;
            me.loadPresidi(me.strutturaOptions[0].id);
          } else {
            me.strutturaOptions.unshift({
              codiceStruttura: null,
              denominazione: "-Seleziona Struttura-",
            });
          }
          this.$emit("afterLoadData");
        })
        .catch(() => {
          this.$emit("afterLoadData");
        });
    },

    onAggiungiImpegnativa() {
      let me = this;
      let idCreato = self.crypto.randomUUID().toString();
      let impegnativa = {
        id: idCreato,
        nome: (me.jsonData.nre += me.jsonData.nonEsente ? " " + me.jsonData.codiceEsenzione : " Non Esente"),
      };
      me.impegnative.push(impegnativa);
    },
    onBeforeLoadData() {
      let me = this;
      me.showModalLoading = false;
    },
    onAfterLoadData() {
      let me = this;
      me.showModalLoading = false;
    },
    onChangeAccettazioneJSON(json) {
      this.$emit("updateJsonData", json);
    },
    onChangeAccettazioneAnagraficaJSON(json) {
      this.$emit("updateJsonData", json);
    },
  },
  watch: {
    selectedCheckBoxs: {
      immediate: true,
      deep: true,
      handler(array) {
        //let me = this;
        array;
      },
    },
    isResidenzaUgualeDomicilio: {
      immediate: true,
      deep: true,
      handler(valore) {
        let me = this;
        if (valore) {
          if (me.jsonData) {
            me.jsonData.provinciaDomicilio = me.jsonData.provinciaResidenza;
            me.jsonData.comuneDomicilio = me.jsonData.comuneResidenza;
            me.jsonData.indirizzoDomicilio = me.jsonData.indirizzoResidenza;
            me.jsonData.capDomicilio = me.jsonData.capResidenza;
          }
        } else {
          (me.jsonData.comuneDomicilio = null), (me.jsonData.provinciaDomicilio = null), (me.jsonData.indirizzoDomicilio = null), (me.jsonData.capDomicilio = null);
        }
      },
    },
    isSprovistoDocumento: {
      immediate: true,
      deep: true,
      handler(valore) {
        let me = this;
        if (valore) {
          me.jsonData.documento = "SPROVISTO";
        } else {
          me.jsonData.documento = null;
        }
      },
    },
  },
};
</script>

<style></style>
